export default __webpack_public_path__ + "static/media/backgroundNotAllowLocation.308ef832.png";